import styled from 'styled-components';

export const HeaderWrapper = styled.div`
  text-align: center;
  line-height: 2.5;
  margin: 100px 0 70px 0;

  @media (max-width: 640px) {
    margin: 60px 0 40px 0;
  }

  [class*='RichTextstyles__ParsedContentWrapper'] {
    h1,
    h2,
    h3,
    h4,
    h5,
    h6,
    p {
      margin-top: 2em;
    }
  }
`;

export const DynamicHeaderWrapper = styled.div`
  [class*='Headingstyle__Heading-sc'] {
    font-weight: 400 !important;
  }
`;

export const HeadingTextWrapper = styled.span`
  font-weight: 400;
`;

export const BackButton = styled.div`
  margin-top: 30px;
  display: flex;
  gap: 10px;
  align-items: flex-start;
  align-self: flex-end;
  cursor: pointer;

  p {
    font-size: 20px;
  }

  [class*='Iconstyle__Icon-sc'] {
    margin-top: 3px;

    @media (max-width: 757px) {
      margin-top: 0.5px;
    }
  }
`;
